import { Injectable } from '@angular/core';
import { VuConnectionHttpService } from './vu-connection-http.service';
import { ComponentRect } from '../models/component-rect';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';

@Injectable()
export class TouchKeyboardService {

  keyboardPositionChange = new Subject<ComponentRect>();
  subscription: Subscription;

  constructor(
    private vuConnectionHttpService: VuConnectionHttpService,
  ) {

    this.subscription = this.keyboardPositionChange
      .pipe(
        debounceTime(1000),
        switchMap((componentRect: ComponentRect) => {
          if (componentRect != null) {
            return this.vuConnectionHttpService.touchKeyboardShow(componentRect);
          } else {
            return this.vuConnectionHttpService.touchKeyboardHide();
          }
        })
      )
      .subscribe();
  }

  show(componentRect: ComponentRect): void {
    this.keyboardPositionChange.next(componentRect);
  }

  hide(): void {
    this.keyboardPositionChange.next(null);
  }
}
